import { Hub } from '@aws-amplify/core';
import { ReducedCookieStorage } from 'config';
import $$api from 'models/api';
import navigate from 'models/router-gate';
import { storage } from 'models/store-global';

import env from 'constants/env';

import AuthService from 'services/AuthService';

import { MyStore } from 'types/Store';
import { type TempUser } from 'types/zod/temp-user';

const TempUsersService = {
    PASSWORD: '12345678',

    createTempUser: async () => {
        const username = `temp+${new Date().getTime()}-${Math.floor(
            Math.random() * (99999 - 10000) + 10000,
        )}@myadvocate.com`;

        const user = {
            username,
            password: TempUsersService.PASSWORD,
        };

        const signUpAttributes = {
            username: username,
            password: TempUsersService.PASSWORD,
            attributes: {
                given_name: 'temp',
                'custom:middle_name': '',
                family_name: 'temp',
                'custom:suffix': '',
                birthdate: '1980-01-01',
                phone_number: '+11111111111',
                'custom:address_line_1': 'temp',
                'custom:address_line_2': '',
                'custom:city': 'temp',
                'custom:state_code': 'HI',
                'custom:zip': '12345',
            },
        };

        await AuthService.signUp(signUpAttributes);
        await AuthService.complexSignIn(user);
        storage.set((store): MyStore => ({ ...store, startAssessment: true }));

        return user;
    },

    isTempUser: (email: string): boolean => {
        return !!(email && email.startsWith('temp+') && email.endsWith('@myadvocate.com'));
    },

    switchToTempUser: async () => {
        AuthService.cleanCognitoCookies();

        let tempUser = {} as TempUser;
        try {
            tempUser = await $$api.participants.getTempUserFx();
            if (!tempUser.awsId) {
                return false;
            }
        } catch (e) {
            return false;
        }

        const keyPrefix = `CognitoIdentityServiceProvider.${(env.awsconfig as any).aws_user_pools_web_client_id}`;
        const fullKeyPrefix = `${keyPrefix}.${tempUser.awsId}`;

        const newUserData = {
            [`${fullKeyPrefix}.idToken`]: tempUser.idToken,
            [`${fullKeyPrefix}.accessToken`]: tempUser.accessToken,
            [`${fullKeyPrefix}.refreshToken`]: tempUser.refreshToken,
            [`${fullKeyPrefix}.clockDrift`]: '0',
            [`${keyPrefix}.LastAuthUser`]: tempUser.awsId,
            [`${fullKeyPrefix}.userData`]: `{"UserAttributes":[{"Name":"sub","Value":"${tempUser.awsId}"},{"Name":"birthdate","Value":"1980-01-01"},{"Name":"email_verified","Value":"true"},{"Name":"phone_number_verified","Value":"false"},{"Name":"given_name","Value":"temp"},{"Name":"custom:city","Value":"temp"},{"Name":"custom:state_code","Value":"HI"},{"Name":"custom:zip","Value":"12345"},{"Name":"phone_number","Value":"+11111111111"},{"Name":"family_name","Value":"temp"},{"Name":"custom:address_line_1","Value":"temp"},{"Name":"email","Value":"${tempUser.email}"}],"Username":"${tempUser.awsId}"}`,
            'amplify-signin-with-hostedUI': 'false',
        } as any;

        for (const key in newUserData) {
            ReducedCookieStorage.setItem(key, newUserData[key]);
        }

        Hub.dispatch('auth', {
            event: 'signIn',
        });

        storage.set((store): MyStore => ({ ...store, startAssessment: true }));
        navigate('/');
        return true;
    },
};

export default TempUsersService;
